import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgxAuthzModule } from '@privatelib/ngx18-authz-dev';

import { SpeechToTextService } from "./services/speech-to-text/speech-to-text.service";
//modules
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from "./shared/shared.module";
import { MaterialModule } from "./material.module";
import { provideFuse } from '@fuse';
import { NgxSpinnerModule, NgxSpinnerComponent } from "ngx-spinner";

//components
import { AppComponent } from './app.component';
/**
 * todo : remove after migration
 */
import {
  PageNotFoundComponent,
  Error500Component
} from "./components";

//services
import { RequestInterceptorService } from './services/http/request-interceptor/request-interceptor.service';
import { ResponseInterceptorService } from './services/http/response-interceptor/response-interceptor.service';
import { LookupService } from './services/lookup/lookup.service';

import { environment } from '../environments/environment';

import { mockApiServices } from './mock-api';
import { provideIcons } from 'app/core/icons/icons.provider';


export function initializeSpeechSDK(lookupService: LookupService) {
  return async () => {
    if (localStorage.getItem('idToken') && localStorage.getItem('authToken')) {
      await lookupService.initSpeechService();
    } else {
      const fragment = location.hash.substring(1);
      if (fragment) {
        const tokenSet = fragment.split('&');
        const tokens = Object.fromEntries(tokenSet.map((e) => e.split("=")));
        if (tokens?.idToken && tokens?.authToken) {
          localStorage.setItem('idToken', tokens?.idToken);
          localStorage.setItem('authToken', tokens?.authToken);
          await lookupService.initSpeechService();
        }
      } else if (location.search.includes('sdk')) {
        const tokenSet = location.search.substring(1).split('&');
        const tokens = Object.fromEntries(tokenSet.map((e) => e.split("=")));
        try {
          const config = JSON.parse(decodeURIComponent(tokens?.sdk));
          SpeechToTextService.init(config);
        } catch (error) {
          console.error(error);
        }
      }
    }
  }
}

export const httpInterceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: RequestInterceptorService,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ResponseInterceptorService,
    multi: true,
  },
];


@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    Error500Component
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgxAuthzModule,
    SharedModule,
    MaterialModule,
    NgxSpinnerComponent,
    NgxSpinnerModule.forRoot()
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [

    {
      provide: 'environment', useValue: environment
    },
    provideAnimationsAsync(),
    httpInterceptorProviders,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeSpeechSDK,
      deps: [LookupService],
      multi: true
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideIcons(),
    provideFuse({
      mockApi: {
        delay: 0,
        services: mockApiServices,
      },
      fuse: {
        layout: 'modern',
        scheme: 'light',
        screens: {
          sm: '600px',
          md: '960px',
          lg: '1280px',
          xl: '1440px',
        },
        theme: 'theme-brand',
        themes: [
          {
            id: 'theme-default',
            name: 'Default',
          },
          {
            id: 'theme-brand',
            name: 'Brand',
          },
          {
            id: 'theme-teal',
            name: 'Teal',
          },
          {
            id: 'theme-rose',
            name: 'Rose',
          },
          {
            id: 'theme-purple',
            name: 'Purple',
          },
          {
            id: 'theme-amber',
            name: 'Amber',
          },
        ],
      },
    }),
  ]
})
export class AppModule { }
